import React, {useState, useEffect} from 'react';
//import {useDispatch} from "react-redux";
import DataGrid, {
    Column,
    FilterRow, 
    ColumnChooser, Export,
    Paging,
    Pager, 
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import {Button} from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import * as Utils from '../../utils/Utils';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import './KurumPersonelDetay.scss';

const KurumPersonelDetay = (props) => {

  //  const dispatch = useDispatch();

    const listeBasligi = "Personel Detayları";
    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const [store, setStore] = useState(null);
    const [filterMap , setFilterMap]  = useState(null);
    const [remoteOperation, setRemoteOperation] = useState(true);
    const [gridExcelExport, setGridExcelExport] = useState(false);

    useEffect(() => { 
        if (props.data) {
            setRemoteOperation(false);
            setGridExcelExport(true);

        }
        setStore(new CustomStore({key:'id'}));
        setFilterMap(Utils.getFilterMap(dataGrid));   
    }, [])

    useEffect(() => {
        if (props.data) {
            setRemoteOperation(false);
            setGridExcelExport(true);
        }
        if(filterMap){
            domainListYukle(); 
            setStore(getStore());
        }       
    }, [filterMap])

    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    let dataGrid = null;
    let treeView = null;


    const getStore = () => { 
        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {
                console.log("loadOptions",loadOptions);
                if(loadOptions.searchOperation == undefined){
                    return;
                }  

                let filterArr = [];
              
                if (treeBoxValue.length > 0) {
                    filterArr.push({
                        property: "domainDonem.domain.id",
                        operator: "IN",
                        value: treeBoxValue,
                        type: "Long"
                    })
                }
                if (props.data) {
                    filterArr.push({
                        property: "domainDonem.domain.id",
                        operator: "=",
                        value: props.data.domainId,
                        type: "Long"
                    });
                    filterArr.push({
                        property: "domainDonem.donem.id",
                        operator: "=",
                        value: props.data.donemId,
                        type: "Long"
                    });
                }

                let params = Utils.getGridLoadOptionsParams(loadOptions, filterMap, filterArr);


                const request = new Request("/kurumPersonelDetay/getKayitList" + params, "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }

    // let store = getStore();

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                      ref={(ref) => treeView = ref}
                      dataStructure="plain"
                      keyExpr="id"
                      parentIdExpr="parent.id"
                      selectionMode="multiple"
                      showCheckBoxesMode="normal"
                      selectNodesRecursive={true}
                      displayExpr="name"
                      selectByClick={true}
                      onContentReady={syncTreeViewSelection}
                      onItemSelectionChanged={treeView_itemSelectionChanged}
            />
        );
    }

    const yenile = () => {
        setStore(getStore());
    }
   
    function onExporting(e) {
        //setRemoteOperation(false);
        let fileName = "";
        treeDataSource.map(sd => {
            if (treeBoxValue.indexOf(sd.id) > -1 && sd.sicilNo != null && sd.sicilNo != "") {
                fileName += sd.name;

            }
        });

        if (fileName == "") {
            fileName = "aphb";
        }
        fileName = fileName.substring(0, 100);

        e.fileName = fileName;

        //e.cancel = true;
     //   setRemoteOperation(true);
    }

    return (
        <div>
            {
                props.data ? null : <h2 className={'dx-icon-product'}>{listeBasligi}</h2> 
              
            }
            {
                props.data ? null :
                    <div className="dx-field">
                        <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                            <DropDownBox
                                value={treeBoxValue}
                                valueExpr="id"
                                displayExpr="name"
                                placeholder="Firma Seçiniz..."
                                showClearButton={true}
                                dataSource={treeDataSource}
                                onValueChanged={syncTreeViewSelection}
                                contentRender={treeViewRender}
                            />
                            <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }}
                                onClick={yenile}></Button>
                        </div>
                    </div> 
            }
            
            

            <DataGrid
                className= { props.gridClassName ? props.gridClassName : "personelGrid"}
                ref={ref => dataGrid = ref}
                width="100%"
                //height="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                onExporting={onExporting}
                //defaultFocusedRowIndex={0}
                columnAutoWidth={false}
                //columnHidingEnabled={true}
                //onToolbarPreparing={onToolbarPreparing}
                selection={{mode: 'multiple', deferred:true}}
                remoteOperations={remoteOperation}
                >
                <FilterRow visible={true}/>
                <Export enabled={gridExcelExport} allowExportSelectedData={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."}/>


                <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20,30, 50, 100, 200,500,2000]} showInfo={true}  visible={true} />
                <Paging defaultPageSize={20}/>

                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false}/>
                <Column dataField={'personel.tcKimlikNumarasi'} width={90} caption={'Tck No'} dataType="string" mappingType="String" visible={true}/>
                <Column dataField={'personel.adi'} width={90} caption={'Adı'} dataType="string" mappingType="String" visible={true}/>
                <Column dataField={'personel.soyadi'} width={90} caption={'Soyadi'} dataType="string" visible={true}/>
                <Column dataField={'personel.ilkSoyadi'} width={90} caption={'IlkSoyadi'} dataType="string" visible={true}/>

                <Column dataField={'ucret'} width={70} caption={'Ücret'} dataType="number" visible={true} mappingType="double"/>
                <Column dataField={'ikramiye'} width={70} caption={'İkramiye'} dataType="number" visible={true} mappingType="double"/>
                <Column dataField={'gun'} width={70} caption={'Gün'} dataType="number" mappingType="int" visible={true}/>
                <Column dataField={'eksikGun'} width={70} caption={'Eksik Gün'} dataType="number" mappingType="int" visible={true}/>
                <Column dataField={'ggun'} width={70} caption={'G-Gün'} dataType="number" mappingType="int" visible={true}/>
                <Column dataField={'cgun'} width={70} caption={'C-Gün'} dataType="number" mappingType="int" visible={true}/>
                <Column dataField={'egn'} width={70} caption={'Egn'} dataType="number"  mappingType="int" visible={true}/>
                <Column dataField={'icn'} width={70} caption={'İcn'} dataType="number" mappingType="int" visible={true}/>


                <Column dataField={'meslek.kodu'} width={70} caption={'Meslek Kodu'} dataType="string" visible={true}/>
                <Column dataField={'belgeMahiyet'} width={70} caption={'Belge Mahiyeti'} dataType="string" visible={true}/>
                <Column dataField="domainDonem.tesvikKanunu.kanunNumarasi" width={70} caption={'Kanun'} dataType="string" visible={true}/>
                <Column dataField={'domainDonem.belgeTuru'} width={40}  caption={'BelgeTürü'} dataType="string" visible={true}/>


                <Column dataField="domainDonem.tesvikKanunu.adi" width={70} caption={'Kanun Adı'} dataType="string" visible={true}/>
                <Column dataField={'domainDonem.domain.name'} width={250}  caption={'Domain'} dataType="string" visible={true}/>
                <Column dataField={'personel.sosyalGuvenlikNumarasi'} width={90} caption={'SGK No'} dataType="string" mappingType="String" visible={true}/>
                <Column dataField="domainDonem.donem.donem" width={70} caption={'Dönem'} dataType="string" visible={true}/>
                <Column dataField={'ortam'} width={70} caption={'Ortam'} dataType="string" visible={false}/>
                <Column dataField={'meslek.adi'} width={70} caption={'Meslek'} dataType="string" visible={false}/>
                

            </DataGrid>
        </div>
    )
}

export default KurumPersonelDetay;
